module.exports = __webpack_public_path__ + "img/prize-02.2d9d8ade.png";